import { FC } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import { SourceListTabContainer_Query } from "~/src/__relay_artifacts__/SourceListTabContainer_Query.graphql";

import { SourceListTab } from "./presentations";

export type Props = {
  siteSlug: string;
};

const query = graphql`
  query SourceListTabContainer_Query {
    viewer {
      role
    }
    ...SourceListTab_root
  }
`;

export const SourceListTabContainer: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ siteSlug }) => {
  const { viewer, ...data } = useLazyLoadQuery<SourceListTabContainer_Query>(
    query,
    {}
  );
  const isAdmin = viewer.role === "ADMIN" || viewer.role === "SUPER";

  return <SourceListTab rootRef={data} siteSlug={siteSlug} isAdmin={isAdmin} />;
};
